import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import React, { Suspense, useState, useReducer, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hot } from 'react-hot-loader/root';
import useBrand from 'wfui-digital-core/es/useBrand';
import useDevice from 'wfui-digital-core/es/useDevice';
import withStrings from 'wfui-digital-core/es/withStrings';
import ErrorBoundary from '../../error-boundary/ErrorBoundary';
import SuspenseOverlay from '../../suspense-overlay/SuspenseOverlay';
import { showModuleError } from '../../../lib/store/module-error/actions';
import { closeGlobalSearch } from '../../../lib/store/global-search/actions';
import GlobalSearchContext from './context/GlobalSearchContext';
import SearchRecord from './state/global-search-record';
import { default as _fetchResults } from './common/fetch-results/fetch-results';
import { setResults as _setResults, clearSuggestions, setNoResultsFound } from './state/api';
import searchReducer from './state/search-reducer';
var GlobalSearchDesktop = /*#__PURE__*/React.lazy(function () {
  return import(
  /* webpackChunkName: "GlobalSearchDesktop" */
  './desktop/GlobalSearchDesktop');
});
var initialState = new SearchRecord();

var GlobalSearch = function GlobalSearch(_ref) {
  var getString = _ref.getString;
  var brand = useBrand();
  var device = useDevice();
  var reduxDispatch = useDispatch();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      searchField = _useState2[0],
      setSearchField = _useState2[1];

  var _useReducer = useReducer(searchReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var globalSearchActive = useSelector(function (_ref2) {
    var core = _ref2.core;
    return core.globalSearch.open;
  });
  var childWindowIsOpen = useSelector(function (_ref3) {
    var digitalCore = _ref3.digitalCore;
    return digitalCore.childWindows.childWindows.size > 0;
  });
  useEffect(function () {
    childWindowIsOpen && reduxDispatch(closeGlobalSearch());
  }, [childWindowIsOpen, reduxDispatch]);

  var fetchResults = function fetchResults() {
    var searchValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state.searchValue;
    dispatch(clearSuggestions());
    dispatch(setNoResultsFound(false));

    _fetchResults({
      searchValue: searchValue,
      searchMode: state.searchMode,
      setResults: function setResults(results) {
        return dispatch(_setResults(results));
      },
      dispatch: dispatch,
      reduxDispatch: reduxDispatch,
      getString: getString
    });
  };

  var searchContext = {
    reduxDispatch: reduxDispatch,
    dispatch: dispatch,
    brand: brand,
    device: device,
    searchField: searchField,
    setSearchField: setSearchField,
    fetchResults: fetchResults,
    searchValue: state.searchValue,
    lastSearchedValue: state.lastSearchedValue,
    suggestions: state.suggestions,
    spelling: state.spelling,
    results: state.results,
    noResultsFound: state.noResultsFound,
    ctaUrl: state.ctaUrl,
    focusSuggestions: state.focusSuggestions,
    highlightIndex: state.highlightIndex,
    searchMode: state.searchMode,
    getString: getString
  };
  return /*#__PURE__*/React.createElement(GlobalSearchContext.Provider, {
    value: searchContext
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    action: function action() {
      return dispatch(showModuleError);
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(SuspenseOverlay, null)
  }, globalSearchActive && /*#__PURE__*/React.createElement(GlobalSearchDesktop, null))));
};

export default hot(withStrings(GlobalSearch));